module.exports = __webpack_public_path__ + "static/OpenSans-SemiBold-e1c83f9474e0cc1d84a13c6d1ddf3ca5.ttf";